<template>
    <div :class="classes">
        <button
            @click="$emit('click', $event)"
            :type="type"
            :class="buttonClasses"
            :disabled="disabled"
            v-ripple="rippleColor"
        >
            <slot></slot>
        </button>
    </div>
</template>
<script>
    import { Ripple } from '../../directives';
    import theme from './button.scss';

    export default {
        name: 'button',
        props: {
            type: {
                type: String,
                default: 'button'
            },
            disabled: Boolean,
            primary: Boolean,
            danger: Boolean,
            raised: {
                type: Boolean,
                default: true,
            },
            flat: {
                type: Boolean,
                default: false,
            },
            ripple: {
                type: Boolean,
                default: true,
            },
            block: {
                type: Boolean,
                default: false,
            },
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    [this.theme.wrapper]: true,
                    [this.theme.isBlock]: this.block,
                }
            },
            buttonClasses() {
                return {
                    [this.theme.button]: true,
                    [this.theme.isBlock]: this.block,
                    [this.theme.isPrimary]: this.primary,
                    [this.theme.isDanger]: this.danger,
                    [this.theme.isRaised]: this.raised && !this.flat,
                    [this.theme.isFlat]: this.flat,
                    [this.theme.isDisabled]: this.disabled,
                }
            },
            rippleColor() {
                switch (true) {
                    case this.flat && this.primary:
                        return 'rgba(3, 169, 244, .1)';
                    case this.flat && this.danger:
                        return 'rgba(255, 82, 82, .1)';
                    case this.danger:
                    case this.primary:
                        return 'rgba(255, 255, 255, .15)';
                    default:
                        return 'rgba(100, 100, 100, .1)';
                }
            }
        },
        directives: {
            Ripple,
        },
    }
</script>


// WEBPACK FOOTER //
// Button.vue?e8b01298